import { combineReducers } from 'redux'
import {
  REALISASI_ERROR,
  REALISASI_LOADING,
  REALISASI_SUCCESS
} from './constant'

const realisasiError = (state = false, action) => {
  switch (action.type) {
    case REALISASI_ERROR:
      return action.realisasiError
    default:
      return state
  }
}

const realisasiLoading = (state = false, action) => {
  switch (action.type) {
    case REALISASI_LOADING:
      return action.realisasiLoading
    default:
      return state
  }
}

const realisasiSuccess = (state = false, action) => {
  switch (action.type) {
    case REALISASI_SUCCESS:
      return action.realisasiSuccess
    default:
      return state
  }
}

const realisasi = (state = [], action) => {
  switch (action.type) {
    case REALISASI_SUCCESS:
      return action.realisasi
    default:
      return state
  }
}

const realisasiReducer = combineReducers({
  realisasiError,
  realisasiLoading,
  realisasiSuccess,
  realisasi
})

export default realisasiReducer
